import { createContext, useContext } from 'react';

export type ViewMode = 'flow' | 'dataflow';

export const ViewModeContext = createContext<ViewMode>('flow');
export const useViewMode = () => useContext(ViewModeContext);
